import { useState, useEffect } from "react";
import { Row, Card, CardBody, CardTitle, Collapse, Table } from "reactstrap";
// router dom
import { useLocation } from "react-router-dom";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// componentes
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import DeleteButton from "../../../components/Buttons/DeleteButton";
import ModalNewMenu from "./ModalNewMenu";
import ModalEditMenu from "./ModalEditMenu";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
//posição da tabela
import ReactDragListView from "react-drag-listview";
// service
import {
  getButtons,
  setButtonsOrder,
  deleteButton,
} from "../../../utils/services/portalEvents/portalEventsButtonsMenu";

export default function MenuPortal() {
  const location = useLocation();
  const idEvent = location.state.idEvent;
  // pesquisas
  const [search, setSearch] = useState("");
  // collapse
  const [isOpen, setIsOpen] = useState(false);
  // listagem
  const [buttonsList, setButtonsList] = useState([]);
  const [isDirty, setIsDirty] = useState(false);
  // modais
  const [modalNewMenu, setModalNewMenu] = useState(false);
  const [modalEditMenu, setModalEditMenu] = useState(false);
  // alerta
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleted, setDeleted] = useState(false);
  // selecionado para deletar
  const [selectedToDelete, setSelectedToDelete] = useState({});
  // selecionado para editar
  const [selectedToEdit, setSelectedToEdit] = useState({});
  // loading
  const [isLoading, setIsLoading] = useState(false);

  function onDragEnd(fromIndex, toIndex) {
    if (toIndex < 0) return;

    const items = [...buttonsList];
    const item = items.splice(fromIndex, 1)[0];
    items.splice(toIndex, 0, item);
    setIsDirty(true);
    setButtonsList(items);
    const data = items.map((e, i) => {
      return { ...e, order: ++i };
    });
    setButtonsOrder({ buttons: data });
  }

  function deleteButtonFunc() {
    deleteButton(selectedToDelete.id)
      .then((res) => {
        if (res.message === "BUTTON_DELETED") {
          setConfirmDelete(false);
          setDeleted(true);
        }
      })
      .catch((error) => console.log("delete erro", error));
  }

  function getListButtons() {
    setIsLoading(true);
    getButtons(idEvent)
      .then((res) => {
        // console.log('ok', res)
        if (res.message === "BUTTONS_LIST" && res.listButtons.total > 0) {
          setButtonsList(
            res.listButtons.data.sort((a, b) => a.order - b.order)
          );
        } else setButtonsList([]);
      })
      .catch((error) => console.log("erro", error))
      .finally(() => setIsLoading(false));
  }

  useEffect(() => {
    getListButtons();
  }, []);

  return (
    <>
      {modalNewMenu && (
        <ModalNewMenu
          isOpen={modalNewMenu}
          toggle={() => setModalNewMenu(false)}
          idEvent={idEvent}
          buttonsList={buttonsList}
          getListButtons={getListButtons}
        />
      )}

      {modalEditMenu && (
        <ModalEditMenu
          isOpen={modalEditMenu}
          toggle={() => setModalEditMenu(false)}
          idEvent={idEvent}
          getListButtons={getListButtons}
          selectedToEdit={selectedToEdit}
        />
      )}

      {confirmDelete && (
        <SweetAlert
          title={`Deseja deletar ${
            selectedToDelete ? selectedToDelete.name : ""
          }?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            deleteButtonFunc();
          }}
          onCancel={() => setConfirmDelete(false)}
        >
          <a>Você não poderá reverter essa ação!</a>
        </SweetAlert>
      )}

      {deleted && (
        <SweetAlert
          success
          title={"Sucesso"}
          onConfirm={() => {
            getListButtons();
            setDeleted(false);
          }}
        >
          Botão deletado com sucesso
        </SweetAlert>
      )}

      <Card>
        <CardBody>
          <CardTitle>Menu do Portal</CardTitle>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>

              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                <ActionButtonRounded
                  title="Criar Botão"
                  onClick={() => setModalNewMenu(true)}
                  type="mobile"
                />
              </Collapse>
            </div>
            <div className="header-btns-container">
              <ActionButtonRounded
                title="Criar Botão"
                onClick={() => setModalNewMenu(true)}
              />
            </div>
          </div>

          <div className="table-responsive">
            <ReactDragListView onDragEnd={onDragEnd}>
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Ordem</th>
                    <th>Tipo do Botão</th>
                    <th>Nome de Exibição</th>
                    <th>Visível</th>
                    <th>Externo</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <LoadingSkelentonTable lines={10} cols={6} />
                  ) : (
                    buttonsList &&
                    buttonsList.length > 0 &&
                    buttonsList
                      .filter(
                        (e) =>
                          e.type
                            .toLocaleLowerCase()
                            .indexOf(search.toLocaleLowerCase()) > -1
                      )
                      .map((e, i) => (
                        <tr key={i} style={{ cursor: "move" }}>
                          <th scope="row">{!isDirty ? e.order : ++i}</th>
                          <td>{e.type}</td>
                          <td>{e.name}</td>
                          <td>{e.isVisible ? "Sim" : "Não"}</td>
                          <td>{e.external ? "Sim" : "Não"}</td>
                          <td>
                            <i
                              className="mdi mdi-pencil"
                              style={{
                                color: "green",
                                fontSize: 17,
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                console.log(e);
                                console.log(modalEditMenu);
                                setSelectedToEdit(e);
                                setModalEditMenu(true);
                              }}
                            />
                            <DeleteButton
                              onClick={() => {
                                setSelectedToDelete(e);
                                setConfirmDelete(true);
                              }}
                              color="red"
                              fontSize={17}
                            />
                          </td>
                        </tr>
                      ))
                  )}
                </tbody>
              </Table>
            </ReactDragListView>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
